import { AuthState } from './auth.models';
import { authLogin, authLogout, authLoginFailure, authLoginRequest, 
  authLoginSuccess, authLogoutFailure, authLogoutRequest, authLogoutSuccess } from './auth.actions';
import { createReducer, on, Action } from '@ngrx/store';

export const initialState: AuthState = {
  isAuthenticated: false,
  persona_id: null,
  token: null,
  user: null,
  isLoading: false,
  error: null,
};

const reducer = createReducer(
  initialState,
  on(authLogout, (state) => ({
    ...state,
    isAuthenticated: false,
    persona_id: null
  })),
  on(authLoginRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null    
  })),
  on(authLoginSuccess, (state, {user}) => ({
    ...state,
    user: user,
    isLoading: false,
    isAuthenticated: true,
    error: null    
  })),
  on(authLoginFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  }))
);

export function authReducer(
  state: AuthState | undefined,
  action: Action
): AuthState {
  return reducer(state, action);
}
